import React, { useState, useEffect, Fragment } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import classNames from 'classnames';

import { formatDateWithTz } from 'Helpers/dateUtils';
import { formatFigure, formatSeparateByThousands } from 'Helpers/formatService';

import Button from 'CommonComponents/Button';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function SpectatorDailyMovementsIndex(props) {
    const [request, setRequest] = useState(false);
    const [sessions, setSessions] = useState([]);
    const [displayRows, setDisplayRows] = useState({});

    let dateToCompare = null;

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        axios
            .get(props.dataUrl)
            .then((res) => {
                const displays = {};
                res.data.sessionsData.forEach((row, index) => {
                    const id = Object.keys(row)[0];
                    const ingressKey = 'ingress_' + id;
                    const egressKey = 'egress_' + id;

                    if (index === 0) {
                        dateToCompare = row[id].ingress.date;
                    }

                    displays[ingressKey] = displays[ingressKey] || false;
                    displays[egressKey] = displays[egressKey] || false;
                });

                setDisplayRows(displays);
                setSessions(res.data.sessionsData);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    const toggleVisibility = (key) => {
        const visibility = JSON.parse(JSON.stringify(displayRows));
        visibility[key] = !visibility[key];
        setDisplayRows(visibility);
    };

    const download = () => {
        const url = props.downloadUrl;
        const fileName = 'spectator_daily_movements.xlsx';

        axios({
            url: url,
            method: 'POST',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-justify-end tw-mb-6">
                <Button variant="primary" onClick={() => download()}>
                    <div>{$t('Download excel')}</div>
                </Button>
            </div>
            <div className="inbud-table_wrapper tw-max-h-[75vh] tw-overflow-scroll">
                <table className="inbud-table tw-table-auto tw-overflow-scroll">
                    <thead>
                        <tr className="*:tw-sticky *:tw-top-0">
                            <th></th>
                            <th>{$t('Date')}</th>
                            <th>{$t('Venue')}</th>
                            <th>{$t('Event')}</th>
                            <th>{$t('Session Name')}</th>
                            <th>{$t('Type')}</th>
                            <th>{$t('Description')}</th>
                            <th>{$t('Time')}</th>
                            <th>{$t('Quantity')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sessions.map((item) => {
                            const id = Object.keys(item)[0];
                            const ingressKey = 'ingress_' + id;
                            const egressKey = 'egress_' + id;

                            return (
                                <Fragment key={id}>
                                    {item[id].ingress.map((row, index) => {
                                        const change = dateToCompare !== row.date;
                                        dateToCompare = row.date;

                                        return (
                                            <tr
                                                key={`${ingressKey}_${index}`}
                                                className={classNames({
                                                    'tw-cursor-pointer': index === 0,
                                                    '!tw-bg-white': index !== 0,
                                                    'tw-hidden': index !== 0 && !displayRows[ingressKey],
                                                })}
                                                onClick={() => index === 0 && toggleVisibility(ingressKey)}
                                            >
                                                <td>
                                                    {index === 0 &&
                                                        (displayRows[ingressKey] ? (
                                                            <ChevronUpIcon className="tw-h-3 tw-w-3 tw-mx-auto" />
                                                        ) : (
                                                            <ChevronDownIcon className="tw-h-3 tw-w-3 tw-mx-auto" />
                                                        ))}
                                                </td>
                                                <td className="inbud-date-cell">{formatDateWithTz(row.date, 'YYYY-MM-DD', 'DD-MM-YYYY')}</td>
                                                <td>{row.venue}</td>
                                                <td>{row.sport}</td>
                                                <td>{row.sessionName}</td>
                                                <td>{row.type}</td>
                                                <td>{row.description}</td>
                                                <td className="inbud-date-cell">{row.time}</td>
                                                <td className="inbud-numeric-cell">
                                                    {formatFigure(row.quantity, formatSeparateByThousands, { precision: 3 })}
                                                </td>
                                            </tr>
                                        );
                                    })}

                                    {item[id].egress.map((row, index) => {
                                        return (
                                            <tr
                                                key={`${egressKey}_${index}`}
                                                className={classNames({
                                                    'tw-cursor-pointer': index === 0,
                                                    '!tw-bg-white': index !== 0,
                                                    'tw-hidden': index !== 0 && !displayRows[egressKey],
                                                })}
                                                onClick={() => index === 0 && toggleVisibility(egressKey)}
                                            >
                                                <td>
                                                    {index === 0 &&
                                                        (displayRows[egressKey] ? (
                                                            <ChevronUpIcon className="tw-h-3 tw-w-3 tw-mx-auto" />
                                                        ) : (
                                                            <ChevronDownIcon className="tw-h-3 tw-w-3 tw-mx-auto" />
                                                        ))}
                                                </td>
                                                <td className="inbud-date-cell">{formatDateWithTz(row.date, 'YYYY-MM-DD', 'DD-MM-YYYY')}</td>
                                                <td>{row.venue}</td>
                                                <td>{row.sport}</td>
                                                <td>{row.sessionName}</td>
                                                <td>{row.type}</td>
                                                <td>{row.description}</td>
                                                <td className="inbud-date-cell">{row.time}</td>
                                                <td className="inbud-numeric-cell">
                                                    {formatFigure(row.quantity, formatSeparateByThousands, { precision: 3 })}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td colSpan={9} className="!tw-py-0"></td>
                                    </tr>
                                </Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

if (document.getElementById('spectatorDailyMovements')) {
    const rootEl = document.getElementById('spectatorDailyMovements');
    ReactDOM.render(
        <App>
            <SpectatorDailyMovementsIndex dataUrl={dataUrl} downloadUrl={downloadUrl} />
        </App>,
        rootEl,
    );
}
